import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const approveForSubmitArticle = async function approveForSubmitArticle() {
  try {
    await this.$store.dispatch("updateSubmissionStatus", {
      action: "APPROVE",
      params: {
        id: this.item.id,
        reviewEdit: {
          contentTypeId: this.item.contentTypeId,
          eventId: this.item.eventId || null,
          communityId: this.item.communityId || null,
        },
        emailContent: this.model || null,
      },
    });
  } catch (error) {
    if (
      error.status &&
      error.status.find((err) => err.message === "Access Denied")
    ) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }

  this.$root.$emit("change-view", {
    view: "administration-dashboard?show=new-submissions",
  });
};

export default approveForSubmitArticle;
